<template>
  <div class="section3">
    <nav-menu @click="$emit('open')"></nav-menu>
    <div class="section3-main__wrapper">
      <div class="profile">
        <div class="profile__left">
          <img src="../../assets/home/profile.png" alt="" />
        </div>
        <div class="profile__right">
          <div class="profile-title">创始人</div>
          <div class="profile-name">José Calbet Benach</div>
        </div>
      </div>
      <div class="section3-desc">
        <p>
          1983年，INDIBA创始人 Jose Calbet
          先生将电效应与热效应完美结合，得到了西班牙国王的赞许。同年，首台设备诞生， 公司注册成立。
        </p>
        <p>
          39年来，
          始终专注于Proionic<sup>®</sup>技术的研发，其产品领域涵盖DEEP CARE、运动康复、美容、及动物健康，基于特定频率448千赫兹的突破性技术，帮助人们抵抗衰老及疼痛，恢复自然健康美丽。
        </p>
        <p>为了更好的服务中国市场， 英特波(深圳)科技有限公司注册成立。</p>
      </div>
      <div class="section3-years-container">
        <van-swipe
          class="my-swipe"
          :autoplay="2000"
          indicator-color="rgba(245, 245, 245, 0.79)"
        >
          <van-swipe-item v-for="(item,index) in yearsConfig" :key="index">
            <div class="swiper-item-left">
              <img v-if="item.img" :src="item.img" alt="图片加载失败" />
            </div>
            <div class="swiper-item-right">
              <div class="year">{{ item.year }}</div>
              <div
                v-for="(items, index) in item.content"
                :key="index"
                class="desc"
              >
                {{ items }}
              </div>
            </div>
          </van-swipe-item>
          <!-- <van-swipe-item>2</van-swipe-item>
          <van-swipe-item>3</van-swipe-item>
          <van-swipe-item>4</van-swipe-item> -->
        </van-swipe>
        <div class="section3-get-more">查看更多信息</div>
      </div>
    </div>
  </div>
</template>

<script>
import NavMenu from "./components/NavMenu.vue";
import { yearsConfig } from "../../const";
export default {
  components: {
    NavMenu,
  },
  data() {
    return {
      yearsConfig,
    };
  },
};
</script>

<style lang="less" scoped>
.section3-main__wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.section3 {
  height: 100%;
  padding: 1.8rem;
  position: relative;

  .profile {
    display: flex;
    align-items: flex-end;
    padding-bottom: 0.5rem;
    .profile__left {
      padding-right: 1.3rem;
      img {
        width: 7.75rem;
        height: 10rem;
      }
    }
    .profile-title {
      font-size: 0.875rem;
      color: rgba(0, 0, 0, 0.85);
      opacity: 0.45;
    }
    .profile-name {
      font-size: 0.9rem;
      color: rgba(0, 0, 0, 0.85);
      font-weight: 500;
    }
  }

  .section3-desc {
    color: #000000;
    opacity: 0.65;
    font-weight: 400;
    font-size: 1rem;
    font-weight: 400;
    flex-grow: 1;
    max-height: 22rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    p {
      font-family: Arial;
      color: #000000;
      margin-bottom: 0.5rem;
      line-height: 1.5rem;
    }
  }

  .section3-get-more {
    color: rgba(0, 26, 112, 0.9);
    font-size: 0.875rem;
    margin-top: 1rem;
  }
}

.my-swipe .van-swipe-item {
  padding: 0.75rem;
  max-height: 9.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(245, 245, 245, 0.79);

  .swiper-item-left {
    width: 7rem;
    // height: 90px;
    // border: 1px solid red;
  }
  .swiper-item-right {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    // justify-content: space-around;
    .year {
      font-size: 1.25rem;
      color: rgba(0, 26, 112, 0.9);
    }
    .desc {
      width: 10.75rem;
      font-size: 0.75rem;
      font-family: Arial;
      font-weight: 400;
      line-height: 17px;
      color: #000000;
      opacity: 0.65;
    }
  }
}
</style>
